import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Loader2 } from 'lucide-react';
import { BookingHeader } from './BookingHeader';

/**
 * Interstitial: Stripe took the card but our /payment/confirm hasn't
 * flipped the booking row yet (webhook still catching up). Shown
 * instead of the false "Booking Confirmed" that iteration_52 hit.
 */
export const SettlingScreen = ({ shop, themeClass, pageStyle, heroStyle, logoStyle }) => (
  <div className={`booking-page ${themeClass}`} style={pageStyle} data-testid="booking-page">
    <BookingHeader shop={shop} heroStyle={heroStyle} logoStyle={logoStyle} />
    <div className="booking-container">
      <div className="booking-success" data-testid="payment-settling">
        <div className="success-icon"><Loader2 className="spin" size={40} /></div>
        <h2>Payment received — finalising your booking</h2>
        <p>
          We&apos;ve taken your payment. It usually takes a few seconds for
          the shop to see your booking. You&apos;ll receive a confirmation
          email as soon as it&apos;s ready.
        </p>
        <p style={{ marginTop: 12, fontSize: 13, opacity: 0.7 }}>
          If this screen persists for more than a minute, contact the
          shop directly with your payment reference.
        </p>
      </div>
    </div>
  </div>
);

/**
 * Success screen shown when the booking is fully created + paid (or
 * paid-not-required). Wired to a "Book another appointment" reset
 * handler + a "Back to shop" link.
 */
export const ConfirmedScreen = ({ shop, themeClass, pageStyle, heroStyle, logoStyle, booking, onReset }) => {
  const bookingDate = new Date(booking.date);
  const formattedDate = bookingDate.toLocaleDateString('en-GB', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });
  return (
    <div className={`booking-page ${themeClass}`} style={pageStyle} data-testid="booking-page">
      <BookingHeader shop={shop} heroStyle={heroStyle} logoStyle={logoStyle} />
      <div className="booking-container">
        <div className="booking-success">
          <div className="success-icon">
            <Check size={48} strokeWidth={3} />
          </div>
          <h2>Booking Confirmed!</h2>
          <p className="success-message">
            {booking.emailSent === false ? (
              <>
                Thanks {booking.customerName}! Your booking is confirmed &mdash; we couldn&apos;t send a confirmation email to <strong>{booking.customerEmail}</strong> right now, but everything else is set. Save the details below.
              </>
            ) : (
              <>
                Thanks {booking.customerName}! We&apos;ve sent a confirmation email to <strong>{booking.customerEmail}</strong>
              </>
            )}
          </p>

          <div className="confirmed-details">
            <div className="detail-row"><span className="label">Service</span><span className="value">{booking.service}</span></div>
            <div className="detail-row"><span className="label">Barber</span><span className="value">{booking.barber}</span></div>
            <div className="detail-row"><span className="label">Date</span><span className="value">{formattedDate}</span></div>
            <div className="detail-row"><span className="label">Time</span><span className="value">{booking.time}</span></div>
          </div>

          <button className="btn-primary" onClick={onReset}>
            Book Another Appointment
          </button>
          <Link
            to={`/shop/${shop.subdomain}`}
            className="back-btn"
            data-testid="booking-back-to-shop-link"
            style={{ marginTop: 12, textDecoration: 'none', display: 'inline-flex', justifyContent: 'center' }}
          >
            ← Back to shop
          </Link>
        </div>
      </div>
    </div>
  );
};
